import { getApi } from './api_instance'

export const holdingsTable = async (
  { filterData = null, page, pageSize = 10, searchQuery = '' },
  dispatch
) => {
  try {
    filterData = JSON.stringify(filterData)
    return await getApi({
      apiUrl: `/projects/api/holdings/myHoldings?filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      sendToken: true,
      dispatch
    })
  } catch (error) {
    throw error
  }
}
